import { useEffect, useState } from "react";
import { getOfflineSyncSummary, OFFLINE_SYNC_CHANGED_EVENT } from "./db";
import type { OfflineSyncSummary } from "./types";

const EMPTY_SUMMARY: OfflineSyncSummary = {
  queued: 0,
  syncing: 0,
  failed: 0,
  needsReview: 0,
  pending: 0,
};

export function useOfflineSyncSummary(): OfflineSyncSummary {
  const [summary, setSummary] = useState<OfflineSyncSummary>(EMPTY_SUMMARY);

  useEffect(() => {
    let cancelled = false;

    const refresh = async () => {
      try {
        const next = await getOfflineSyncSummary();
        if (!cancelled) setSummary(next);
      } catch {
        if (!cancelled) setSummary(EMPTY_SUMMARY);
      }
    };

    void refresh();
    window.addEventListener(OFFLINE_SYNC_CHANGED_EVENT, refresh);
    window.addEventListener("online", refresh);
    window.addEventListener("offline", refresh);

    return () => {
      cancelled = true;
      window.removeEventListener(OFFLINE_SYNC_CHANGED_EVENT, refresh);
      window.removeEventListener("online", refresh);
      window.removeEventListener("offline", refresh);
    };
  }, []);

  return summary;
}
